import { useSelector } from "react-redux";
import { DefaultRootState } from "@reduxLocal/persistState";

/**
 * Active scope id for API calls and data queries: selected company, else target user
 * context, else authenticated personal account.
 * userData.id always remains the logged-in user; targetUserId scopes invited-user views.
 */
const useGlobalUser = () => {
  const userData = useSelector((state: DefaultRootState) => state.promiseData.data?.userData);
  const companyData = useSelector((state: DefaultRootState) => state.promiseData.data?.companyData);
  const currentCompany = useSelector((state: DefaultRootState) => state.app.selectedProfile);

  if (currentCompany?.id) {
    return currentCompany.id;
  }
  if (userData?.targetUserId) {
    return userData.targetUserId;
  }
  if (userData?.id) {
    return userData.id;
  }
  return companyData?._id ?? companyData?.id;
};

export default useGlobalUser;
